/* unplugin-vue-components disabled */import { render } from "./input-text.vue?vue&type=template&id=4942e9aa&scoped=true"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"

import "./input-text.vue?vue&type=style&index=0&id=4942e9aa&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4942e9aa"],['__file',"src/components/chat-input/input-text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4942e9aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4942e9aa', __exports__)) {
    api.reload('4942e9aa', __exports__)
  }
  
  module.hot.accept("./input-text.vue?vue&type=template&id=4942e9aa&scoped=true", () => {
    api.rerender('4942e9aa', render)
  })

}


export default __exports__